import React from 'react';

type LinkIconProps = {
  className?: string;
  size?: number;
};

const LinkIcon: React.FC<LinkIconProps> = ({
  className = '',
  size = 18,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M352 144h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c70.7 0 128-57.3 128-128s-57.3-128-128-128zM256 304h-96c-35.3 0-64-28.7-64-64s28.7-64 64-64h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96C89.3 112 32 169.3 32 240s57.3 128 128 128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32z" />
    </svg>
  );
};

export default LinkIcon;
